import { it, en } from '@formkit/i18n'

export default {
  locales: { it, en },
  locale: 'it',
}
